module.exports = __webpack_public_path__ + "static/media/logo.3b3e4a0b.webp";